import React from 'react';
import TestimonialCarousel from './TestimonialCarousel';
import FeatureList from './FeatureList';
import TrustBadges from './TrustBadges';
import { TESTIMONIALS } from '../../../config/socialProof';

/**
 * SocialProofPanel Component
 * Right-side panel combining testimonial carousel, features, and trust badges
 */
const SocialProofPanel = () => {
    const panelStyle = {
        padding: '32px 20px',
        backgroundColor: '#FFFFFF',
    };

    return (
        <div className="social-proof-panel" style={panelStyle}>
            {TESTIMONIALS && TESTIMONIALS.length > 0 && (
                <TestimonialCarousel testimonials={TESTIMONIALS} />
            )}

            <FeatureList />

            <TrustBadges />
        </div>
    );
};

export default SocialProofPanel;
